import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { WeekDay } from '../dto/habit.enum';

interface SelectorProps<T> {
  selectedDays: T[];
  setSelectedDays: Dispatch<SetStateAction<T[]>>;
}

export function WeekDaySelector({ selectedDays, setSelectedDays }: SelectorProps<WeekDay>) {
  const { t } = useTranslation();

  const toggleDay = (day: WeekDay) => {
    setSelectedDays((prev) => (prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]));
  };

  return (
    <div className="flex flex-wrap gap-2 justify-between">
      {Object.values(WeekDay).map((day) => {
        const isSelected = selectedDays.includes(day);
        return (
          <button
            key={day}
            type="button"
            className={`btn btn-square ${
              isSelected ? 'btn-primary' : 'border-primary text-primary hover:bg-transparent hover-primary'
            }`}
            onClick={() => toggleDay(day)}
          >
            {t(day)}
          </button>
        );
      })}
    </div>
  );
}

export function MonthDaySelector({ selectedDays, setSelectedDays }: SelectorProps<number>) {
  const daysInMonth = 31;

  const toggleDay = (day: number) => {
    setSelectedDays((prev) => (prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]));
  };

  return (
    <div className="flex flex-wrap gap-2 justify-between">
      {[...Array(daysInMonth)].map((_, i) => {
        const day = i + 1;
        const isSelected = selectedDays.includes(day);
        return (
          <button
            key={day}
            type="button"
            className={`btn btn-square ${
              isSelected ? 'btn-primary' : 'border-primary text-primary hover:bg-transparent hover-primary'
            }`}
            onClick={() => toggleDay(day)}
          >
            {day}
          </button>
        );
      })}
    </div>
  );
}
